export function StatCard({ label, value, icon: Icon, accent = "text-primary", sub, index = 0 }) {
  return (
    <div
      className="bg-card border border-border p-6 hover:-translate-y-0.5 hover:shadow-sm transition-transform animate-fade-up"
      style={{ animationDelay: `${index * 60}ms` }}
      data-testid="stat-card"
    >
      <div className="flex items-start justify-between">
        <div className="overline">{label}</div>
        {Icon && <Icon className={`h-5 w-5 ${accent}`} strokeWidth={1.6} />}
      </div>
      <div className="mt-3 text-3xl font-display font-bold tracking-tight">{value}</div>
      {sub && <div className="mt-1 text-xs text-muted-foreground">{sub}</div>}
    </div>
  );
}

export function SectionTitle({ children, action }) {
  return (
    <div className="flex items-center justify-between mb-4">
      <h2 className="text-lg font-display font-bold tracking-tight">{children}</h2>
      {action}
    </div>
  );
}

export function StatusBadge({ status }) {
  const map = {
    pending: "bg-amber-100 text-amber-800",
    approved: "bg-emerald-100 text-emerald-800",
    rejected: "bg-red-100 text-red-800",
    suspended: "bg-zinc-200 text-zinc-700",
    info_requested: "bg-blue-100 text-blue-800",
    published: "bg-emerald-100 text-emerald-800",
    draft: "bg-zinc-200 text-zinc-700",
    in_progress: "bg-blue-100 text-blue-800",
    under_evaluation: "bg-amber-100 text-amber-800",
    submitted: "bg-blue-100 text-blue-800",
    not_attempted: "bg-zinc-100 text-zinc-600",
  };
  const label = (status || "").replace(/_/g, " ");
  return (
    <span className={`inline-block px-2 py-0.5 text-[11px] font-medium uppercase tracking-wide ${map[status] || "bg-zinc-100 text-zinc-600"}`}>
      {label}
    </span>
  );
}
